import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "date-list-nav" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-arrow-down icon-rotate-90 date-list-nav__button-arrow",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_4 = { class: "visually-hidden" }
const _hoisted_5 = { class: "date-list-nav__button-text" }
const _hoisted_6 = { class: "date-list-nav__month" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "date-list-nav__button-text" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-arrow-down icon-rotate-270 date-list-nav__button-arrow",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_10 = { class: "visually-hidden" }
const _hoisted_11 = { class: "date-list" }
const _hoisted_12 = { class: "form-check form-check--primary" }
const _hoisted_13 = ["value", "checked", "disabled", "onChange"]
const _hoisted_14 = { class: "date-list__item-date" }
const _hoisted_15 = { class: "text-uppercase" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 1,
  class: "date-list__item-availability"
}
const _hoisted_18 = {
  key: 2,
  class: "date-list__item-availability"
}
const _hoisted_19 = { class: "date-list__item-price" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["date-list-grid", _ctx.isLoading ? 'date-list-grid--is-loading' : ''])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "date-list-nav__button date-list-nav__button--prev",
        disabled: _ctx.checkIfPrevDisabled(),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.prevShownCalendar()))
      }, [
        _hoisted_3,
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.translate('shop.ticket.configuration.calendar.prev-button')), 1),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.getPreviousMonthName(_ctx.dateConfig.month)) + " " + _toDisplayString(_ctx.getPreviousYear(_ctx.dateConfig.year, _ctx.dateConfig.month)), 1)
      ], 8, _hoisted_2),
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.getMonthName(_ctx.dateConfig.month)) + " " + _toDisplayString(_ctx.dateConfig.year), 1),
      _createElementVNode("button", {
        class: "date-list-nav__button date-list-nav__button--next",
        disabled: _ctx.checkIfNextDisabled(),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.nextShownCalendar()))
      }, [
        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.getNextMonthName(_ctx.dateConfig.month)) + " " + _toDisplayString(_ctx.getNextYear(_ctx.dateConfig.year, _ctx.dateConfig.month)), 1),
        _hoisted_9,
        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.translate('shop.ticket.configuration.calendar.next-button')), 1)
      ], 8, _hoisted_7)
    ]),
    _createElementVNode("div", _hoisted_11, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dateConfig.dates, (item) => {
        return (_openBlock(), _createElementBlock("label", {
          class: _normalizeClass(["date-list__item", {
                      'is-selected' : _ctx.selectedDateStart === item.dateStart,
                      'is-disabled': item.availableTickets === 0
                    }]),
          key: item.dateStart
        }, [
          _createElementVNode("span", _hoisted_12, [
            _createElementVNode("input", {
              type: "radio",
              name: "date-list",
              class: "form-check-input",
              value: item.id,
              checked: _ctx.selectedDateStart === item.dateStart,
              disabled: item.availableTickets === 0,
              onChange: ($event: any) => (_ctx.onSelectDate(item))
            }, null, 40, _hoisted_13)
          ]),
          _createElementVNode("span", _hoisted_14, [
            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.getLocaleDateString(item.dateStart)), 1),
            (item.dateEnd)
              ? (_openBlock(), _createElementBlock("span", _hoisted_16, " - " + _toDisplayString(_ctx.getLocaleDateString(item.dateEnd)), 1))
              : _createCommentVNode("", true),
            (item.availableTickets > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(item.availableTickets) + " " + _toDisplayString(_ctx.translate('shop.ticket.configuration.available')), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.translate('shop.ticket.configuration.sold-out')), 1))
          ]),
          _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.translate('shop.ticket.configuration.from')) + " CHF " + _toDisplayString(item.priceByPriceGroup[_ctx.defaultPriceGroupId]?.price), 1)
        ], 2))
      }), 128))
    ])
  ], 2))
}